import { Link, makeStyles } from '@fluentui/react-components';
import React from 'react';
import { LinkifiedLinkProps, LinkifiedText } from '../../utils/LinkifiedText';

const useClasses = makeStyles({
    link: {
        // Forum and help-article URLs are long and have no break points, so one would overflow the bubble.
        overflowWrap: 'anywhere',
    },
});

// `inline` underlines the link, so it doesn't stand out by colour alone in running text (WCAG 1.4.1).
const SupportLink: React.FC<LinkifiedLinkProps> = (props) => {
    const classes = useClasses();
    return <Link inline className={classes.link} {...props} />;
};

interface SupportMessageTextProps {
    text: string;
}

// A support agent writes plain text, like the customer, but pastes forum and help-article links the
// customer should be able to click (#2826).
export const SupportMessageText: React.FC<SupportMessageTextProps> = ({ text }) => (
    <LinkifiedText text={text} linkAs={SupportLink} />
);
